import React, { Component } from "react";
import { MapPin, Search, ChevronRight } from "react-feather";
import pin from "../img/pin.svg";
import user2 from "../img/map/us2.png";
import user1 from "../img/map/us1.png";
import { Input } from "reactstrap";
import { connect } from "react-redux";
class Maps extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }
  addDefaultSrc(ev) {
    ev.target.src = user1;
  }
  render() {
    return (
      <>
        <div>
          <div class="lg:flex md:flex ">
            <card class="w-4/6">
              <div className="relative">
                <iframe
                  className="w-full map-h600px"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.741509089975!2d77.59145181399889!3d12.988377990844889!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1668358762b9%3A0xba97603afab98c97!2sICICI%20Bank%2C%20Cunningham%20Rd%2C%20Vasanth%20Nagar%2C%20Bengaluru%2C%20Karnataka%20560051!5e0!3m2!1sen!2sin!4v1620567246465!5m2!1sen!2sin"
                  loading="lazy"
                ></iframe>
                <div className="absolute abs-map">
                  <div className="relative">
                    <Input
                      type="text"
                      name="search"
                      className="cust-search480 shadow-md p-4 mob-fsize12 rounded-full "
                      placeholder="Search opening in your desired location "
                    />
                    <Search
                      size={15}
                      width="20"
                      height="20"
                      className="absolute search-icon-tr"
                    />
                  </div>
                </div>
              </div>
            </card>

            <card class="w-2/6 relative cust-mapashadow rounded-lg">
              <div className="p-6">
                <div>
                  <p className="fsize18 opacity-70per text-black sm-fsize10">
                    25 Results
                  </p>
                  <h1 className="fsize20 font-medium text-black sm-fsize16">
                    Bangalore, Karnataka
                  </h1>
                </div>
                <div className="mt-6 scrollbar56vh">
                  <div className="p-2">
                    {this.props.GETMOREJOBS &&
                    this.props.GETMOREJOBS.Data.length > 0
                      ? this.props.GETMOREJOBS.Data.map((datajobs, index) => {
                          return (
                            <card className="cust-shadow-box w-full flex map-status-info p-4 mb-3" key={index}>
                              <div>
                                <img
                                  onError={this.addDefaultSrc}
                                  src={
                                    process.env.REACT_APP_IMAGE_BASE_MG +
                                    "/" +
                                    datajobs.f_path
                                  }
                                  className="w-46px h-46px rounded-full"
                                />
                              </div>

                              <div className="ml-4">
                                <h3 className="text-black fsize16 font-medium line-clamp-1">
                                  {datajobs.f_title}
                                </h3>

                                <div className="flex justify-between mt-1">
                                  <div className="flex items-center">
                                    <img src={pin} className="pn-icon-w" />
                                    <p className="text-blue1  fsize14 ml-2  ">
                                      {datajobs.Location || "INDIA"}
                                    </p>
                                  </div>

                                  <p className="text-muted-1 fszie14 font-normal">
                                    3d ago
                                  </p>
                                </div>
                                <div className="flex items-center mt-2">
                                  <p className="applynow-t ml-2 fsize14">
                                    Apply now
                                  </p>

                                  <ChevronRight
                                    width="15px"
                                    height="15px"
                                    className="text-blue1"
                                  />
                                </div>
                              </div>
                            </card>
                          );
                        })
                      : ""}
                  </div>
                </div>
              </div>
            </card>
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    GETMOREJOBS: state.Home.home.GETMOREJOBS,
    Auth: state.Auth.user,
  };
};

export default connect(mapStateToProps)(Maps);
